const reviews = [
  {
    id: 1,
    name: "susan smith",
    job: "web developer",
    image:
      "https://res.cloudinary.com/diqqf3eq2/image/upload/v1586883334/person-1_rfzshl.jpg",
    text: "Here I've been able to work with wonderful people and the best tools available to date. I can confidently say I've improved as a developer thanks to the great people I've met!",
  },
  {
    id: 2,
    name: "anna johnson",
    job: "web designer",
    image:
      "https://res.cloudinary.com/diqqf3eq2/image/upload/v1586883409/person-2_np9x5l.jpg",
    text: "Communication was key in having this be a relaxing workplace. Many times I've struggled to get my point accross to the rest of a dev team; not this time. I've enjoyed my time here a lot.",
  },
  {
    id: 3,
    name: "peter jones",
    job: "intern",
    image:
      "https://res.cloudinary.com/diqqf3eq2/image/upload/v1586883417/person-3_ipa0mj.jpg",
    text: "I've learned a lot from my time here, putting my skills to the test every day and every chance I could. I'm very happy to say I've grown from this experience and I'd be glad to work here again!",
  },
  {
    id: 4,
    name: "bill anderson",
    job: "the boss",
    image:
      "https://res.cloudinary.com/diqqf3eq2/image/upload/v1586883423/person-4_t9nxjt.jpg",
    text: "As my first experience being the lead of a team, I'm quite pleased with the quality of both the work environment and coworkers. This shall be my new minimum standard in future projects.",
  },
];

export default reviews;
